<nav class="navbar navbar-expand-lg navbar-light fixed-top" id="mainNav" sytle="background-color:black">
    <div class="container">
      <a class="navbar-brand" href="/Manage/main">Kim's Log - Manager</a>
      <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
        Menu
        <i class="fas fa-bars"></i>
      </button>
      <div class="collapse navbar-collapse" id="navbarResponsive">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <a class="nav-link" href="/main">Home</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="javascript:location.href='/Manage/noticeboard/s/1'">NoticeBoard</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="javascript:location.href='/Manage/baekjoon/s/1'">Baekjoon</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>